'use strict';

DataService.$inject = ['mx.SolutionBuilderAgent.Http'];
export function DataService(http) {
	var fragmentUrl = 'api/data/fragments/';
	var objectUrl = 'api/data/objects/';

	return {
		Fragments: {
			add: addFragment,
			addRelation: addFragmentRelation,
			get: getFragment,
			getList: getFragmentsList,
			getRelationList: getFragmentRelationList,
			update: updateFragment,
			delete: deleteFragment,
			deleteRelation: deleteFragmentRelation,
		},
		Objects: {
			add: addObject,
			get: getObject,
			update: updateObject,
			delete: deleteObject,
		},
	};

	function addFragment(ddName, fragment) {
		return http.post(fragmentUrl + ddName, fragment).then();
	}

	function addFragmentRelation(ddName, fragmentId, relationName, relationFragmentId) {
		return http.post(fragmentUrl + ddName + '/' + fragmentId + '/' + relationName + '/' + relationFragmentId).then();
	}

	function getFragment(ddName, fragmentId) {
		return http.get(fragmentUrl + ddName + '/' + fragmentId).then();
	}

	function getFragmentsList(ddName, request) {
		return http.get(fragmentUrl + ddName, request).then();
	}

	function getFragmentRelationList(ddName, fragmentId, relationName, request) {
		return http.get(fragmentUrl + ddName + '/' + fragmentId + '/' + relationName, request).then();
	}

	function updateFragment(ddName, fragment) {
		return http.put(fragmentUrl + ddName, fragment).then();
	}

	function deleteFragment(ddName, fragmentId) {
		return http.remove(fragmentUrl + ddName + '/' + fragmentId).then();
	}

	function deleteFragmentRelation(ddName, fragmentId, relationName, relationFragmentId) {
		return http.remove(fragmentUrl + ddName + '/' + fragmentId + '/' + relationName + '/' + relationFragmentId).then();
	}

	function addObject(ciName, object) {
		return http.post(objectUrl + ciName, object).then();
	}

	function getObject(ciName, objectId, full) {
		var queryFull = full ? '?full=true' : '';
		return http.get(objectUrl + ciName + '/' + objectId + queryFull).then();
	}

	function updateObject(ciName, object, full) {
		var queryFull = full ? '?full=true' : '';
		return http.put(objectUrl + ciName + queryFull, object).then();
	}

	function deleteObject(ciName, objectId) {
		return http.remove(objectUrl + ciName + '/' + objectId).then();
	}
}
